import { createContext } from 'react';
import { InputContextType } from './InputContext.types';

export const InputContext = createContext<InputContextType>(
  {} as InputContextType,
);
